<div class="main-container-2c">

  <div class="col-left">
    <!--  <div class="col-left-bg"></div> -->
    <div class="brand-info">
      <h3 class="welcome1 anim-text-flow">Welcome to</h3>
      <h1 class="logo-name"><img class="logo-img" src="/assets/img/brand/logo120x120.png"> {{title}}</h1>      
    </div>

  </div>
  <div class="col-right">
 
    <div class="appversion">V{{appversion}}</div>
    <div class="card p-4 boxlogin boxlogin-container">

      <div class="card-body">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <h2>Sign In</h2>
          <p>Enter your credentials</p>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-user"></i></span>
            </div>
            <input type="text" formControlName="username" placeholder="Username" autocomplete="username"
              class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
              <div *ngIf="f.username.errors.required">Username is required</div>
            </div>
          </div>
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-key"></i></span>
            </div>
            <input [type]="fieldTextType ? 'text' : 'password'" formControlName="password" class="form-control"
              placeholder="Password" autocomplete="current-password" required
              [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fa" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}" (click)="toggleFieldTextType()"></i>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 ">
              <div class="form-group text-right">
                <button [disabled]="loadinglist" class="btn btn-primary loginbtn">
                  <span *ngIf="loadinglist" class="spinner-border spinner-border-sm mr-1"></span>
                  Login
                </button>
              </div>
            </div>
            <!-- <div class="col-6 text-right">
                      <button type="button" class="btn btn-link px-0">Forgot password?</button>
                    </div> -->
          </div>
          <div style="position: relative;">
            <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
          </div>

        </form>
      </div>
    </div>

  </div>


</div>
<div class="screenmessage-container">
  <app-frms-messagebar *ngIf="screenmessage" [alertmessage]="screenmessage" [closeable]="true"
[autoHideMillis]="2000"></app-frms-messagebar>       
</div>
